import { Helmet } from 'react-helmet';
import LoginForm from './LoginForm';

function MemberBody() {
  return (
    <div className="member__container">
      <Helmet>
        <meta charSet="utf-8" />
        <title>라이프스팬 - 판매처공지</title>
      </Helmet>
      <div className="member__wrapper column">
        <div className="member__title">
          <h1>판매자 공지사항</h1>
        </div>
        <LoginForm />
      </div>
    </div>
  );
}

export default MemberBody;
